<template>
    <router-view :class="{unauthorized: unauthorized, loading: portalStore.loading}" />
    <notificationElement />
    <Teleport to="#app">
        <PopupConfirm ref="mainConfirmRef" />
    </Teleport>
</template>

<script>
import {defineComponent, onMounted, watch, reactive, computed, provide, ref, inject} from "vue";

import { useRoute, useRouter } from "vue-router";

import PopupConfirm from "components/popupConfirm";
import notificationElement from "components/notifications";

import { init, unauthorized, portalStore, user_id } from "store/portal";

import trans from "helpers/_translation";

// Our styles
import styles from 'css/app.scss';

import { checkLogin } from "services/JwtService";

export default defineComponent({
    name: "app",
    props: {
        application : {
            type: String,
            required: false,
            default: "workflowportal"
        },
        portal_url: { // Used to pass correct portal url from community to portal code
            type: String,
            required: false,
            default: ""
        }
    },
    components: {
        notificationElement,
        PopupConfirm
    },
    setup(props) {

        const mainConfirmRef = ref();

        const router = useRouter();

        const portal_url = computed(() => {
            return props.portal_url.replace("http://", "//");
        });
        const application = computed(() => {
            return props.application;
        });
        const isWorkflowportal = computed(() => {
            return props.application === "workflowportal";
        });
        const isCommunity = computed(() => {
            return props.application === "community";
        });

        const isLeftVisible = ref(false);
        provide("isLeftVisible", isLeftVisible);

        const appData = reactive({
            edited: false
        });
        const handleConfirmAction = () => {
            return new Promise(async (resolve, reject) => {
                let ok = await mainConfirmRef.value?.show({
                    "message": trans("U staat op het punt om een actie uit te voeren. <br>Houd er rekening mee dat wijzigingen definitief kunnen zijn.")
                });
                if (!ok) {
                    return reject();
                }
                return resolve();
            });
        };
        const handleConfirm = () => {
            return new Promise(async (resolve, reject) => {
                if (appData.edited) {
                    let ok = await mainConfirmRef.value?.show();
                    if (!ok) {
                        return reject();
                    }
                }
                appData.edited = false;
                return resolve();
            });
        };
        const handleClick = (name, query = {}) => {
            if (unauthorized.value) return;
            handleConfirm().then(
                () => {

                    router.push({
                        name: name,
                        query: query
                    });
                    // Close the left menu
                    isLeftVisible.value = false;

                },
                () => {
                    // Rejected
                }
            );
        };
        provide("appData",appData);
        provide("handleConfirmAction", handleConfirmAction);
        provide("handleConfirm",handleConfirm);
        provide("handleClick", handleClick);

        console.log("portal_url",portal_url.value);
        console.log("application",application.value);

        provide("portal_url", portal_url);
        provide("application", application);
        provide("isWorkflowportal", isWorkflowportal);
        provide("isCommunity", isCommunity);

        watch(
            () => [unauthorized, user_id],
            (value) => {
                if (unauthorized.value && checkLogin() && user_id.value) {
                    router.push("/");
                }
            },
            {
                deep: true,
                immediate: true
            }
        );

        // NOTE: How does Portal work?
        // 1. We have a 'user' within workflowmanager wingzz (for now) or within auth.ibizz.nl (later)
        //    The user allows us to login
        // 2. Within workflowmanager we have a contact or user board.
        //    This board is a list of contacts or users as workflowcards.
        //    Within our public/env/...json we define which workflowcardtype_id is used for contacts.
        //    The contact is related with the generic link tabel to the 'wingzz' user.
        // 3. Within public/env/...json we define our properties related to contact.
        //    So for example; "fullname": ["gebruiker_voornaam", "gebruiker_achternaam"],
        //    Which defines fullname exists out of gebruiker_voornaam and gebruiker_achternaam.

        onMounted(init);

        return {
            unauthorized,
            portalStore,

            mainConfirmRef
        }
    }
});
</script>